import { render, staticRenderFns } from "./SubmissionFilter.vue?vue&type=template&id=a8c6aeec&scoped=true"
import script from "./SubmissionFilter.vue?vue&type=script&lang=js"
export * from "./SubmissionFilter.vue?vue&type=script&lang=js"
import style0 from "./SubmissionFilter.vue?vue&type=style&index=0&id=a8c6aeec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c6aeec",
  null
  
)

export default component.exports